/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


const getRootCursor = (entity) =>
{
  return entity.parent === null ? entity.cursor : getRootCursor(entity.parent);
};


const rewrap = (entity, rootState, rootCursor) =>
{
  if (entity === null)
  {
    return null;
  }

  return new entity.constructor(entity.cursor.rescope(rootState, rootCursor), rewrap(entity.parent, rootState, rootCursor));
};


export default (entity) =>
{
  const rootCursor = getRootCursor(entity);

  const rootState = { state: rootCursor.get() };

  return rewrap(entity, rootState, rootCursor);
};
